var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1197_8152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3527 3.72573L35.7609 3.65099V6.67687H39.4866V3.65108C39.4867 1.6382 37.8487 0 35.836 0H10.3527C8.33981 0 6.70117 1.6382 6.70117 3.65108V18.5986H10.3844L10.3527 3.72573Z",
    fill: "#0796A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7609 36.5483H10.42L10.4131 33.1298H6.70117V40.3488C6.70117 42.3617 8.33981 43.9999 10.3527 43.9999H35.836C37.8487 43.9999 39.4867 42.3617 39.4867 40.3488V21.208H35.761V36.5483H35.7609ZM23.9947 42.137C23.7181 42.2561 23.4149 42.3236 23.0935 42.3236C22.7746 42.3236 22.4702 42.256 22.1931 42.137C21.3803 41.7881 20.8118 40.9812 20.8118 40.0415C20.8118 38.781 21.8342 37.7593 23.0935 37.7593C24.3539 37.7593 25.3761 38.7809 25.3761 40.0415C25.3762 40.9812 24.8076 41.7881 23.9947 42.137Z",
    fill: "#0796A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3592 33.0336C13.3592 33.5466 13.7219 34.0107 14.1643 34.1938C14.651 34.3956 15.2123 34.2843 15.5859 33.911L16.3653 33.13L17.4567 32.041L22.7114 26.7861C22.9555 26.5413 23.0934 26.2096 23.0934 25.8637C23.0934 25.5183 22.9554 25.1867 22.7114 24.9418L17.4567 19.6863L16.3696 18.5987L15.5859 17.8156C15.2123 17.4429 14.651 17.331 14.1643 17.5328C13.7206 17.7165 13.3619 18.1867 13.3619 18.6745C13.3619 18.9613 13.3586 20.8343 13.3586 20.8343H1.80985C1.08874 20.8343 0.505859 21.4179 0.505859 22.1387V29.591C0.505859 30.3117 1.08874 30.8953 1.80985 30.8953H13.3586C13.3586 30.8953 13.3592 32.9514 13.3592 33.0336Z",
    fill: "#0796A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6293 8.9088H31.0805C31.0805 8.9088 31.0772 7.03575 31.0772 6.74883C31.0772 6.26115 30.7185 5.79101 30.2748 5.60716C29.7881 5.40552 29.2268 5.51737 28.8532 5.88992L28.0695 6.67311L26.9825 7.76067L21.7277 13.0163C21.4837 13.2612 21.3457 13.5928 21.3457 13.9381C21.3457 14.2841 21.4838 14.6157 21.7277 14.8605L26.9825 20.1154L28.0738 21.2044L28.8532 21.9854C29.2268 22.3587 29.7881 22.4701 30.2748 22.2683C30.7172 22.0852 31.08 21.621 31.08 21.1079C31.08 21.0258 31.0805 18.9697 31.0805 18.9697H42.6293C43.3503 18.9697 43.9333 18.386 43.9333 17.6652V10.213C43.9332 9.49221 43.3503 8.9088 42.6293 8.9088Z",
    fill: "#0796A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1197_8152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(0.220703)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainIcon4);
export default __webpack_public_path__ + "static/media/main_icon4.7d7f6e4afca339328ca493b8c9975f17.svg";
export { ForwardRef as ReactComponent };